import { IShop } from "@/types/IShop.interface"
import { IColor } from "@/types/IColor"

export type State = {
    colors: IColor[],
}

export const state: State = {
    colors: [],
}